import 'css-chunk:src/components/card/card-component.module.scss';export default {
  "card-component": "card-component_card-component__jvndg",
  "black": "card-component_black__z5erz",
  "grey": "card-component_grey__GAWAM",
  "white": "card-component_white__8lLYD",
  "ffffff": "card-component_ffffff__29b1k",
  "red": "card-component_red__Hr2fm",
  "rsRed": "card-component_rsRed__Gjzzg",
  "darkRed": "card-component_darkRed__VIJUY",
  "midtoneRed": "card-component_midtoneRed__pdjJx",
  "highlightRed": "card-component_highlightRed__gjCCg",
  "shadowRed": "card-component_shadowRed__-xG4g",
  "purple": "card-component_purple__dPyIP",
  "darkPurple": "card-component_darkPurple__mLWah",
  "transparent": "card-component_transparent__1sdEm",
  "padding": "card-component_padding__X2yJa",
  "shadow-sm": "card-component_shadow-sm__gHbKG",
  "shadow-md": "card-component_shadow-md__4pORa",
  "shadow-lg": "card-component_shadow-lg__vyP5i",
  "corner-round": "card-component_corner-round__UYp5y",
  "card-radius": "card-component_card-radius__0xl03",
  "title": "card-component_title__-JnZR"
};